<template>
  <div class="map">
    <div class="left">
      <!-- <div class="dialog" v-if="show">
        <div class="con">
          <img :src="`/img/title/${icon_step}.png`" class="title" />
          <div class="desc yasong">
            <div class="html" v-html="point_list[show_step].description"></div>
          </div>
        </div>
      </div> -->
      <m-dialog v-if="point_list.length" :show="show" :icon_step="icon_step" :description="point_list[show_step].description"></m-dialog>
      <div class="canvas-area2">
        <canvas id="myCanvas2"></canvas>
      </div>
      <div class="canvas-area">
        <canvas id="myCanvas"></canvas>
      </div>
      <div class="point_list">
        <div class="point" :class="`p-${item} ${step >= item ? 'active' : ''}`" v-for="item in 19" :key="item"></div>
      </div>
      <div class="icon_list">
        <img
          class="icon img-1"
          :class="`img-${item}`"
          :src="`/img/${step >= item ? 'active-icon' : 'icon'}/${item}.png`"
          v-for="item in 19"
          :key="item"
        />
      </div>
      <div class="img">
        <img src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20220921/1663731557-632a876520573.png" class="dashed" />
      </div>
    </div>
    <div class="right">
      <div class="thead">
        <div class="item rank"></div>
        <div class="item name">单车编号</div>
        <div class="item cal">累计数据</div>
      </div>
      <div class="tbody">
        <div class="item" v-for="(item, i) in rank" :key="i">
          <div class="i-item rank">
            <div class="num">{{ i + 1 }}</div>
            <div class="label">TOP</div>
          </div>
          <div class="i-item name">单车 {{ item.device_sn }}</div>
          <div class="i-item cal">
            <div class="num">
              {{ Math.floor(item.total_dist / 100) / 10 }}
              <div class="unit">km</div>
            </div>
            <div class="num">
              {{ item.total_calories }}
              <div class="unit">Cal</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/index'
import { draw } from '../utils/canvas'

import mDialog from './dialog.vue'

let img_load = false

export default {
  components: { mDialog },
  computed: {
    // step() {
    //   if (this.bikes.length) {
    //     const bike = this.bikes.reduce((a, b) => {
    //       return a.finish > b.finish ? a : b
    //     })
    //     return bike.step
    //   } else {
    //     return 0
    //   }
    // },
  },
  data() {
    return {
      step: 0,
      canvas: null,
      ctx: null,
      canvas2: null,
      ctx2: null,

      show: false,

      wait: true,
      finished: true,

      show_step: 1,
      icon_step: 1,

      path: [
        { x: 525, y: 69 },
        { x: 525, y: 129 },
        { x: 457, y: 129 },
        { x: 457, y: 251 },
        { x: 457, y: 291 },
        { x: 336, y: 291 },
        { x: 336, y: 427 },
        { x: 272, y: 427 },
        { x: 272, y: 573 },
        { x: 187, y: 573 },
        { x: 187, y: 710 },
        { x: 290, y: 710 },
        { x: 290, y: 763 },
        { x: 290, y: 880 },
        { x: 490, y: 880 },
        { x: 588, y: 880 },
        { x: 588, y: 977 },
        { x: 660, y: 977 },
        { x: 863, y: 977 },
        { x: 1000, y: 977 },
        { x: 1000, y: 878 },
        { x: 1191, y: 878 },
        { x: 1191, y: 805 },
        { x: 1191, y: 695 },
        { x: 1191, y: 526 },
        { x: 1111, y: 526 },
        { x: 1111, y: 572 },
        { x: 1014, y: 572 },
        { x: 1014, y: 512 },
        { x: 1014, y: 390 },
        { x: 943, y: 390 },
        { x: 828, y: 390 },
        { x: 828, y: 284 },
        { x: 703, y: 284 },
        { x: 703, y: 213 },
        { x: 801, y: 213 },
        { x: 842, y: 213 },
      ],

      bikes: [],

      rank: [],
      point_list: [],
    }
  },
  mounted() {
    this.init()

    this.get_data()
  },
  methods: {
    get_data() {
      api.common.cMap({ stid: this.$route.query.stid, gid: 'eStBcUhqZ0ZvRE09' }).then((r) => {
        this.rank = r.data.orgList
        this.point_list = r.data.subList

        const list = this.bikes

        r.data.orgList.forEach((row) => {
          if (row.total_addressNo > 19) {
            row.total_addressNo = 19
          }

          // const now = new Date().valueOf()
          // const old = row.run_create_time * 1000

          // if (now - old >= 180000) {
          //   row.addressNo = 0
          // }

          const i = this.bikes.findIndex((item) => {
            return item.id == row.device_sn
          })

          row._label = row.label.split('.')[1] * 1

          if (i != -1) {
            if (this.bikes[i].run_create_time != row.run_create_time) {
              this.wait = true

              this.bikes[i] = {
                run_create_time: row.run_create_time,
                finished: false,
                finish: row.addressNo,
                step: 0,
                id: row.device_sn,
                no: row._label,
                i: 0,
                x: 525,
                y: 69,
              }
            } else {
              // const now = new Date().valueOf()
              // const old = row.run_create_time * 1000
              // if (now - old >= 180000) {
              //   this.bikes[i] = {
              //     run_create_time: row.run_create_time,
              //     finished: false,
              //     finish: row.addressNo,
              //     step: 0,
              //     id: row.device_sn,
              //     no: row._label,
              //     i: 0,
              //     x: 525,
              //     y: 69,
              //   }
              // }
            }
          } else {
            list.push({
              run_create_time: row.run_create_time,
              finished: false,
              finish: row.addressNo,
              step: 0,
              id: row.device_sn,
              no: row._label,
              i: 0,
              x: 525,
              y: 69,
            })
          }
        })

        this.bikes = list

        if (this.finished) {
          this.finished = false

          if (this.bikes.length) {
            const bike = this.bikes.reduce((a, b) => {
              return a.step > b.step ? a : b
            })
            this.step = bike.step
          } else {
            this.step = 0
          }

          this.draw_img()
        }

        setTimeout(() => {
          this.get_data()
        }, 3000)

        // setInterval(() => {
        //   this.wait = true
        //   this.bikes[3].finished = false
        //   this.bikes[3].finish = this.bikes[3].finish + 1

        //   if (this.finished) {
        //     this.finished = false
        //     this.draw_img()
        //   }
        // }, 8000)
      })
    },
    on_click(e) {
      const path = this.path

      path.push({
        x: e.x,
        y: e.y,
      })

      const ctx = this.ctx

      ctx.beginPath()

      path.forEach((point, i) => {
        if (!i) {
          ctx.moveTo(point.x, point.y)
        } else {
          ctx.lineTo(point.x, point.y)
        }
      })

      ctx.strokeStyle = '#a41e2e'
      ctx.lineWidth = 10
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
      ctx.stroke()

      // console.log(JSON.stringify(path))
    },
    init() {
      const c = document.getElementById('myCanvas')
      const ctx = c.getContext('2d')
      const c2 = document.getElementById('myCanvas2')
      const ctx2 = c2.getContext('2d')

      c.height = c.clientHeight
      c.width = (c.clientHeight / 1080) * 1282

      c2.height = c2.clientHeight
      c2.width = (c2.clientHeight / 1080) * 1282

      this.canvas = c
      this.ctx = ctx

      this.canvas2 = c2
      this.ctx2 = ctx2
    },
    draw_img() {
      const path = this.path
      const img = new Image()
      img.src = 'https://oss.mcloud.moveclub.cn/mcloudbkh5/20220921/1663748328-632ac8e8251fb.png'

      this.bikes.forEach((bike) => {
        bike.img = img
        bike.x = path[bike.i].x
        bike.y = path[bike.i].y
      })

      // console.log('draw')
      if (!img_load) {
        img.onload = () => {
          this.draw()
        }
      } else {
        this.draw()
      }
    },
    draw() {
      const ctx = this.ctx
      const ctx2 = this.ctx2

      img_load = true

      draw(
        ctx,
        ctx2,
        this.bikes,
        this.path,
        (step) => {
          if (this.step <= step) {
            this.step = step
          }
        },
        (step, show_dialog) => {
          this.finished = true

          if (step == 8 || step == 9) return

          if (step > 10) {
            this.icon_step = step + 1
            this.show_step = step - 2
          } else {
            this.icon_step = step + 1
            this.show_step = step
          }
          if (show_dialog) {
            this.show_img()
          }
        }
      )
    },
    show_img() {
      if (this.wait) {
        this.wait = false
        this.show = true
        setTimeout(() => {
          this.show = false
        }, 6000)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.map {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  align-items: center;
  .left {
    width: 1282px;
    height: 100%;
    background: url(https://oss.mcloud.moveclub.cn/mcloudbkh5/20220921/1663731443-632a86f383c7d.jpg) no-repeat center center / contain;
    position: relative;
    .btn-area {
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 20;
    }
    .canvas-area {
      position: absolute;
      z-index: 9;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      #myCanvas {
        width: 100%;
        height: 100%;
      }
    }
    .canvas-area2 {
      position: absolute;
      z-index: 15;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      #myCanvas2 {
        width: 100%;
        height: 100%;
      }
    }
    .point {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      background: #ffffff;
      border: 9.6px solid rgba(178, 135, 85, 1);
      position: absolute;
      z-index: 13;
      &.active {
        border: 9.6px solid #a41e2e;
      }
      &.p-1 {
        top: 115px;
        left: 440px;
      }
      &.p-2 {
        top: 236px;
        left: 440px;
      }
      &.p-3 {
        top: 273px;
        left: 319px;
      }
      &.p-4 {
        top: 403px;
        left: 319px;
      }
      &.p-5 {
        top: 557px;
        left: 255px;
      }
      &.p-6 {
        top: 557px;
        left: 170px;
      }
      &.p-7 {
        top: 688px;
        left: 170px;
      }
      &.p-8 {
        top: 748px;
        left: 274px;
      }
      &.p-9 {
        top: 858px;
        left: 274px;
      }
      &.p-10 {
        top: 863px;
        left: 472px;
      }
      &.p-11 {
        top: 958px;
        left: 641px;
      }
      &.p-12 {
        top: 958px;
        left: 845px;
      }
      &.p-13 {
        top: 791px;
        left: 1174px;
      }
      &.p-14 {
        top: 678px;
        left: 1174px;
      }
      &.p-15 {
        top: 507px;
        left: 1095px;
      }
      &.p-16 {
        top: 495px;
        left: 998px;
      }
      &.p-17 {
        top: 372px;
        left: 925px;
      }
      &.p-18 {
        top: 372px;
        left: 813px;
      }
      &.p-19 {
        top: 194px;
        left: 784px;
      }
    }
    .icon {
      position: absolute;
      &.img-1 {
        width: 136px;
        height: 113.59px;
        top: 35px;
        left: 296px;
      }
      &.img-2 {
        width: 122.19px;
        height: 108.59px;
        top: 160px;
        left: 487px;
      }
      &.img-3 {
        width: 173.81px;
        height: 129.59px;
        top: 173px;
        left: 137px;
      }
      &.img-4 {
        width: 132.26px;
        height: 108.15px;
        top: 328px;
        left: 367px;
      }
      &.img-5 {
        width: 117.19px;
        height: 114.61px;
        top: 470px;
        left: 295px;
      }
      &.img-6 {
        width: 150.8px;
        height: 129.15px;
        top: 421px;
        left: 63px;
      }
      &.img-7 {
        width: 131.88px;
        height: 135.15px;
        top: 586px;
        left: 35px;
      }
      &.img-8 {
        width: 119.44px;
        height: 90.62px;
        top: 686px;
        left: 317px;
      }
      &.img-9 {
        width: 132.73px;
        height: 88.07px;
        top: 803px;
        left: 131px;
      }
      &.img-10 {
        width: 110.33px;
        height: 106.61px;
        top: 909px;
        left: 398px;
      }
      &.img-11 {
        width: 129.94px;
        height: 121.59px;
        top: 811px;
        left: 642px;
      }
      &.img-12 {
        width: 126px;
        height: 96.8px;
        top: 835px;
        left: 844px;
      }
      &.img-13 {
        width: 199.51px;
        height: 83px;
        top: 741px;
        left: 960px;
      }
      &.img-14 {
        width: 126px;
        height: 110.59px;
        top: 601px;
        left: 1033px;
      }
      &.img-15 {
        width: 126px;
        height: 100.59px;
        top: 400px;
        left: 1096px;
      }
      &.img-16 {
        width: 126px;
        height: 100.59px;
        top: 428px;
        left: 857px;
      }
      &.img-17 {
        width: 130.19px;
        height: 122.59px;
        top: 241px;
        left: 932px;
      }
      &.img-18 {
        width: 126px;
        height: 100.59px;
        top: 319px;
        left: 657px;
      }
      &.img-19 {
        width: 151.19px;
        height: 107.59px;
        top: 71px;
        left: 794px;
      }
    }
    .img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      .dashed {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .right {
    width: 638px;
    height: 100%;
    background: #c5141e url(https://oss.mcloud.moveclub.cn/mcloudbkh5/20220923/1663904047-632d292f5496c.png) no-repeat center top / contain;
    .thead {
      display: flex;
      align-items: center;
      padding-top: 224px;
      padding-bottom: 30px;
      .item {
        color: #fff;
        font-size: 32px;
        &.rank {
          width: 25%;
        }
        &.name {
          width: 50%;
        }
        &.cal {
          width: 25%;
        }
      }
    }
    .tbody {
      .item {
        display: flex;
        align-items: center;
        padding: 0 11px;
        height: 128px;
        &:nth-of-type(odd) {
          background: #b1111a;
          box-shadow: 0px 3px 1px 0px rgba(0, 0, 0, 0.35);
        }
        .i-item {
          color: #fff;
          &.rank {
            width: 86px;
            height: 78px;
            background: #272624;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 27px;
            margin-right: 37px;
            .label {
              font-size: 24px;
              margin-top: -12px;
            }
          }
          &.name {
            width: 235px;
            font-size: 28px;
            margin-right: 94px;
          }
          &.cal {
            font-size: 28px;
            .num {
              width: 127px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              .unit {
                width: 40px;
                font-size: 24px;
                color: rgba(255, 255, 255, 0.65);
                margin-left: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
